import clsx from 'clsx';

interface Props {
  role: 'user' | 'assistant';
  content: string;
}

export function ChatBubble({ role, content }: Props) {
  if (role === 'assistant') {
    return (
      <div className="mb-3">
        <div className="text-[10px] uppercase tracking-wider text-accent-text mb-1">AI Builder</div>
        <div className="bg-surface border border-border rounded-md px-3 py-2 text-sm text-text-primary max-w-[90%] whitespace-pre-wrap">
          {content}
        </div>
      </div>
    );
  }
  return (
    <div className="mb-3 flex justify-end">
      <div
        className="rounded-md px-3 py-2 text-sm text-accent-text max-w-[90%] whitespace-pre-wrap"
        style={{ background: '#FAEEDA' }}
      >
        {content}
      </div>
    </div>
  );
}

export function ThinkingDots() {
  return (
    <div className="mb-3">
      <div className="text-[10px] uppercase tracking-wider text-accent-text mb-1">AI Builder</div>
      <div className="bg-surface border border-border rounded-md px-3 py-2 max-w-[60%] inline-flex items-center gap-1">
        <span className="w-1.5 h-1.5 bg-text-hint rounded-full animate-pulse" />
        <span className="w-1.5 h-1.5 bg-text-hint rounded-full animate-pulse" style={{ animationDelay: '120ms' }} />
        <span className="w-1.5 h-1.5 bg-text-hint rounded-full animate-pulse" style={{ animationDelay: '240ms' }} />
      </div>
    </div>
  );
}
